<template>
  <div class="none">
    <img src="@/assets/imgs/none.png" alt />
    <span>空空如也</span>
    <!-- 展示刷新更多按钮，由于部分页面的运营需求 -->
    <a
      v-if="moreFind"
      :href="moreURL"
      target="_blank"
      v-report="'1003.2449.3001.8300'"
      v-query="'1003.2449.3001.8300'"
    >
      <div class="more-find">
        <div class="bg">
          <img class="plus" src="@/assets/imgs/plus.png" />
        </div>
        <p>{{moreText}}</p>
      </div>
    </a>
  </div>
</template>

<script>
export default {
  props: {
    moreFind: {
      type: Boolean,
      default: false,
    },
    moreURL: {
      type: String,
    },
    moreText: {
      type: String,
      default: "发现更多内容",
    },
  },
};
</script>

<style lang="less" scoped>
.none {
  position: relative;
  padding-top: 150px;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;

  img {
    width: 120px;
    height: 120px;
  }

  span {
    font-size: 14px;
    font-weight: 400;
    color: #8f8fa6;
    line-height: 22px;
  }

  .more-find {
    box-sizing: border-box;
    position: absolute;
    top: 0;
    left: 0;
    border-radius: 8px;
    padding: 10px;
    width: 150px;
    height: 170px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    box-shadow: 0px 0px 16px 0px rgba(0, 0, 0, 0.06);
    user-select: none;
    cursor: pointer;

    .bg {
      position: relative;
      border-radius: 4px;
      width: 100%;
      height: calc(100% - 15px);
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      background: #f5f6f7;

      img {
        width: 18px;
        height: 18px;
      }
    }

    p {
      line-height: 15px;
      font-size: 12px;
      font-weight: 400;
      text-align: center;
      color: #222226;
    }
  }
}
</style>